import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

function ValidationErrors({ errors, isWarning = false }) {
    const { t, locale } = useTranslation()
    const [expanded, setExpanded] = useState(false)
    if (!errors || errors.length === 0) return null

    // Only apply expand/collapse for warnings
    const showExpand = isWarning && errors.length > 3
    const visibleErrors = showExpand && !expanded ? errors.slice(0, 3) : errors

    return (
        <div className={`${isWarning ? 'bg-[#FFF3CD]' : 'bg-[#FC4C5933]'} border-l-[5px] ${isWarning ? 'border-[#FFA500]' : 'border-[#FC4C59]'} p-4 my-6`}>
            <div className="flex">
                <div className="flex-shrink-0">
                    <svg className={`h-5 w-5 ${isWarning ? 'text-[#FFA500]' : 'text-[#FC4C59]'}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                        <path
                            fillRule="evenodd"
                            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                            clipRule="evenodd"
                        />
                    </svg>
                </div>
                <div className="ml-3">
                    <h3 className={`text-sm font-medium ${isWarning ? 'text-[#FFA500]' : 'text-[#FC4C59]'}`}>
                        {isWarning ? t('The following warnings were found') : t('The following errors were found')}:
                    </h3>
                    <div className={`mt-2 text-sm ${isWarning ? 'text-[#FFA500]' : 'text-[#FC4C59]'}`}>
                        <ul className="list-disc pl-5 space-y-1">
                            {visibleErrors.map((error, index) => (
                                <li key={index}>{error}</li>
                            ))}
                        </ul>
                        {showExpand && (
                            <button className="mt-2 text-xs underline text-[#FFA500] focus:outline-none" onClick={() => setExpanded((prev) => !prev)}>
                                {expanded ? t('Show less') : t('Show all')} ({errors.length})
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ValidationErrors
